import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Chinese%20ink%20wash%20painting%20style%20with%20deep%20crimson%20red%20and%20warm%20gold%20accents%2C%20flowing%20organic%20shapes%2C%20modern%20minimalist%20composition%2C%20traditional%20Chinese%20aesthetic%20with%20contemporary%20design%2C%20dramatic%20contrast%2C%20textured%20paper%20effect%2C%20elegant%20and%20bold%20color%20palette&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt="五一吃瓜网"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
              <i className="ri-fire-line text-accent-400 text-sm"></i>
              <span className="text-xs font-medium text-white/90">今日已更新 12 条爆料</span>
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4">
              {siteConfig.name}
              <span className="block text-2xl md:text-3xl lg:text-4xl font-bold text-accent-300 mt-2">
                {siteConfig.slogan}
              </span>
            </h1>
            <p className="text-base md:text-lg text-white/70 max-w-lg mx-auto lg:mx-0 leading-relaxed mb-8">
              {siteConfig.description}，深夜吃瓜不打烊，火速获取最新入口！
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/zonghe"
                className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer text-sm"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="whitespace-nowrap px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium hover:bg-white/25 transition-colors duration-200 cursor-pointer text-sm border border-white/20"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="hidden lg:block flex-1">
            <div className="relative">
              <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden border-2 border-white/20 backdrop-blur-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20traditional%20red%20lanterns%20hanging%20in%20modern%20urban%20night%20scene%2C%20warm%20golden%20glowing%20light%2C%20atmospheric%20cityscape%2C%20elegant%20minimalist%20composition%2C%20cinematic%20mood%2C%20deep%20crimson%20and%20amber%20tones&width=800&height=600&seq=hero-side-01&orientation=landscape"
                  alt="吃瓜热点"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-background-50 rounded-xl p-4 border border-background-200/70">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-flashlight-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">实时热度</p>
                    <p className="text-lg font-bold text-foreground-900">1,280,000+</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}